const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxId2: {
      name: "taxId2",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[06] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    phone: {
      name: "phone",
      label: "[07] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[08] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[09] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label:
        "[09] Tên đơn vị phụ thuộc/địa điểm kinh doanh của hoạt động sản xất kinh doanh khác tỉnh nơi đóng trụ sở chính",
      type: "text",
      placeholder: "",
    },
    conpanyTax: {
      name: "conpanyTax",
      label: "[10] Mã số thuế đơn vị phụ thuộc/Mã số địa điểm kinh doanh",
      type: "text",
      placeholder: "",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[08] Hợp đồng đại lý thuế/số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    BusinessAddress: {
      name: "BusinessAddress",
      label: "[11] Địa chỉ nơi có hoạt động sản xuất kinh doanh khác tỉnh nơi đóng trụ sở chính:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
